var $3da5197535ffe7ea$exports = {};
$3da5197535ffe7ea$exports = {
    "loading": `Na\u{10D}\xedtava sa...`,
    "loadingMore": `Na\u{10D}\xedtava sa viac...`
};


export {$3da5197535ffe7ea$exports as default};
//# sourceMappingURL=sk-SK.mjs.map
